import { useSWRInfinite } from 'swr';
import { PlayerMatchFragment } from '@amf/shared/types/graphql';

export const LIMIT = 5;

const API_KEY = '/api/player/matches';
const getCacheKey =
  (player: string) => (pageIndex: number, prevPageData: PlayerMatchFragment[] | null) => {
    const params = new URLSearchParams({ player, offset: `${LIMIT * pageIndex}` });

    if (prevPageData === null || pageIndex === 0) {
      return `${API_KEY}?${params.toString()}`;
    }

    if (prevPageData.length < LIMIT) {
      return null;
    }

    return `${API_KEY}?${params.toString()}`;
  };

function usePlayerLastMatches(id: string) {
  const { data, error, size, setSize } = useSWRInfinite<PlayerMatchFragment[]>(getCacheKey(id));
  const matches: PlayerMatchFragment[] = data ? ([] as PlayerMatchFragment[]).concat(...data) : [];
  return {
    error,
    matches,
    loading: !data && !error,
    data,
    size,
    setSize,
  };
}

export default usePlayerLastMatches;
